import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import worldmapAnimation from '../ux/animations/worldmap.lottie';

/**
 * LoadingAnimation
 *
 * A reusable loading component that displays a world map Lottie animation
 * with optional text message.
 *
 * Props:
 *  - message: Optional text to display below the animation
 *  - size: Size of the animation ("sm" | "md" | "lg")
 *  - className: Optional additional CSS classes
 */

type Size = 'sm' | 'md' | 'lg';

export interface LoadingAnimationProps {
  message?: string;
  size?: Size;
  className?: string;
}

const sizeMap: Record<Size, { width: number; height: number }> = {
  sm: { width: 150, height: 150 },
  md: { width: 250, height: 250 },
  lg: { width: 350, height: 350 },
};

export const LoadingAnimation: React.FC<LoadingAnimationProps> = ({
  message = 'Loading...',
  size = 'md',
  className = '',
}) => {
  const { width, height } = sizeMap[size];

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div style={{ width, height }}>
        <DotLottieReact
          src={worldmapAnimation}
          loop
          autoplay
        />
      </div>
      {message && (
        <p className="mt-4 text-muted-foreground text-sm md:text-base font-medium">
          {message}
        </p>
      )}
    </div>
  );
};

export default LoadingAnimation;
